import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from  "rxjs";
import { catchError, finalize, map } from 'rxjs/operators';
//import { Settings, CommonData } from '@shared/Models/Settings';
//import { ConstantsService } from 'src/app/shared/services/constants.service';
import {Settings, CommonData, settingPayLoad } from '../classes/Settings';
import { ConstantsService } from './Constants/constants.service';
import { stringify } from 'querystring';
import { AuthService } from './Auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class EmailConfigService {
  private Service_URL: any;
  oldSettings:any;
  SettingsDetails:Settings;
  data: CommonData[]=[];
  constructor(private httpClient:HttpClient) {
    this.Service_URL=ConstantsService;
   }
  globalHeaders(): any {
    //   let headers = new HttpHeaders({
    //     'Content-Type': 'application/json'            
    //  });
      let headers: HttpHeaders = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      headers.append('Access-Control-Allow-Origin', '*');
      headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE');
      headers.append('Access-Control-Allow-Headers', 'Content-Type');
      let options = { headers: headers };
      return options;
  
    }
    getEmailConfigurationData() : Observable<any>
    {
      return this.httpClient.get(this.Service_URL.EmailConfiguration.getconfiguration).
    pipe(map((response) => {
      return response;
    }));
         
    }
    UpdateEmailConfigurationData(config:settingPayLoad[]) : Observable<any>
    {             
    return this.httpClient.put(this.Service_URL.EmailConfiguration.Saveconfiguration,config).
    pipe(map((response) => {
      return response;
    }));   
    }
}
